import React from 'react';
import { historyDetailShape } from 'constants/propTypes';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { codes, paymentMethodTranslation } from 'constants/payment';
import { ActionItemPayment, ActionItemPaymentCell, ActionItemPaymentMethodCell, ActionItemPointsCell } from './HistoryDetail.styles';

import { shouldDisplayReasons } from './HistoryDetails.utils';

const HistoryActionPayment = ({ action, detail }) => {
  const getFormattedCurrencyProps = (payment) => {
    const { amount, currency } = payment;

    return {
      amount,
      currency
    };
  };

  const getPaymentMethodTranslation = (p) => {
    if (p.isDiscountCode) {
      return <FormattedMessage id="discountCodes.reference" />;
    }

    return paymentMethodTranslation[p.method] ? <FormattedMessage id={paymentMethodTranslation[p.method]} /> : p.method;
  };

  const formatReference = (reference) => {
    const pointsStrIndex = reference?.includes('-') && ['balance', 'payout'].includes(reference.split('-')[0]) ? 3 : 0;

    const points = reference?.includes('-') ? reference.split('-')[pointsStrIndex] : undefined;

    return points && !Number.isNaN(Number(points)) ? `${points} points` : '';
  };

  return (
    <ActionItemPayment>
      {detail.data.payments
        .filter((p) => detail.revisionContents[action].includes(p.uuid))
        .map(
          (p) =>
            !p.isPayout && (
              <React.Fragment key={p.uuid}>
                <ActionItemPaymentCell>
                  <FormattedCurrency {...getFormattedCurrencyProps(p)} />
                </ActionItemPaymentCell>

                <ActionItemPaymentCell isDiscountCode={p.isDiscountCode}>
                  {!p.isDiscountCode && (
                    <>
                      <ActionItemPaymentMethodCell>{getPaymentMethodTranslation(p)}</ActionItemPaymentMethodCell>

                      {shouldDisplayReasons(action, p) && (
                        <ActionItemPaymentMethodCell dataCy="override-reason">
                          {p.overrideReason.map((or) => `${or.key?.split('_')?.join(' ')}: ${or.value}`)}
                        </ActionItemPaymentMethodCell>
                      )}
                    </>
                  )}
                  {p.isDiscountCode && (
                    <>
                      <ActionItemPaymentMethodCell>{getPaymentMethodTranslation(p)}</ActionItemPaymentMethodCell>
                      <ActionItemPaymentMethodCell>{p.reference}</ActionItemPaymentMethodCell>
                      <ActionItemPaymentMethodCell>
                        <FormattedCurrency
                          {...getFormattedCurrencyProps({
                            amount: p.discountAmount,
                            currency: p.currency
                          })}
                        />
                      </ActionItemPaymentMethodCell>
                    </>
                  )}
                  {p.method === codes.LOYALTY_POINTS && !!formatReference(p.reference) && (
                    <ActionItemPointsCell>{formatReference(p.reference)}</ActionItemPointsCell>
                  )}
                </ActionItemPaymentCell>
              </React.Fragment>
            )
        )}
    </ActionItemPayment>
  );
};

HistoryActionPayment.propTypes = {
  action: PropTypes.string.isRequired,
  detail: historyDetailShape.isRequired
};

export default HistoryActionPayment;
